import { makeStyles } from '@mui/styles';

export default makeStyles((theme) => ({
	heading: {
		fontWeight: '600',
		color: theme.palette.primary.main
	},
	icon: {
		cursor: 'pointer',
		transform: 'scale(1.5)',
		transition: 'all .3s ease !important',
		'&:hover': {
			transform: 'scale(1.55)'
		},
		'&:active': {
			transform: 'scale(1.3)'
		}
	},
	modalContentStyle: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: 'fit-content !important',
		height: 'fit-content',
		backgroundColor: '#fff',
		boxShadow: 24,
		borderRadius: '10px',
		padding: '1rem',
		overflowY: 'scroll'
	},

	modalContentItem: {
		display: 'flex',
		justifyContent: 'center'
	}
}));
